"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteAllContent = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var deleteContentSlice_1 = require("@features/SettingsPage/state/deleteContentSlice");
var _store_1 = require("@store");
var react_redux_1 = require("react-redux");
var DeleteAllContentJobType_1 = require("@features/SettingsPage/components/DeleteContent/DeleteAllContent/DeleteAllContentJobType");
var date_1 = require("@utils/date/date");
var DeleteContentExplanation_1 = require("@features/SettingsPage/components/common/DeleteContentExplanation");
var Button_1 = __importDefault(require("@components/Button"));
var Modal_1 = __importDefault(require("@components/Modal"));
var ConfirmContentDeletionModal_1 = require("@features/SettingsPage/components/DeleteContent/DeleteAllContent/ConfirmContentDeletionModal");
function Title(_a) {
    var deleteAllContentActivated = _a.deleteAllContentActivated, currentTeamName = _a.currentTeamName;
    var t = (0, react_i18next_1.useTranslation)().t;
    if (deleteAllContentActivated) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h2", { className: "title1" }, currentTeamName),
            react_1.default.createElement("h2", { className: "title2" }, t('settings:DELETE_ALL_CONTENT.TITLE2'))));
    }
    return react_1.default.createElement("h2", { className: "title1" }, t('settings:DELETE_ALL_CONTENT.TITLE1'));
}
function DeleteAllContent(_a) {
    var domain = _a.domain, currentTeamName = _a.currentTeamName, angularJsDependencies = _a.angularJsDependencies;
    var dispatch = (0, _store_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_redux_1.useSelector)(deleteContentSlice_1.deleteAllContentSelector), deleteJobs = _b.deleteJobs, status = _b.status;
    var _c = __read((0, react_1.useState)(false), 2), isModalOpen = _c[0], setIsModalOpen = _c[1];
    var res = {
        willBeDeleted: [
            {
                text: t('settings:DELETE_ALL_CONTENT.WILL_BE_DELETED.TEXT1'),
                icon: 'implioicons-image-1',
            },
        ],
        willNotBeDeleted: [
            {
                text: t('settings:DELETE_ALL_CONTENT.WILL_NOT_BE_DELETED.TEXT1'),
                icon: 'implioicons-statistics',
            },
            {
                text: t('settings:DELETE_ALL_CONTENT.WILL_NOT_BE_DELETED.TEXT2'),
                icon: 'implioicons-team',
            },
            {
                text: t('settings:DELETE_ALL_CONTENT.WILL_NOT_BE_DELETED.TEXT3'),
                icon: 'implioicons-network',
            },
        ],
    };
    var deleteAllContentActivated = deleteJobs && deleteJobs.length > 0;
    var currentJob = (0, react_1.useMemo)(function () {
        if (!deleteJobs || deleteJobs.length === 0) {
            return null;
        }
        if (deleteJobs.length > 1) {
            angularJsDependencies.EvaLogger.captureMessage("There should be only one ongoing delete-all-content job, \n          but there are actually ".concat(deleteJobs.length, " in domain ").concat(domain));
        }
        var newJob = new DeleteAllContentJobType_1.DeleteAllContentJob(deleteJobs[0]);
        angularJsDependencies.deleteAllContent.setShowDeleteAllContentNotice(true);
        angularJsDependencies.deleteAllContent.DeleteAllContentJobsManager.update(domain, newJob);
        return newJob;
    }, [deleteJobs]);
    (0, react_1.useEffect)(function () {
        dispatch((0, deleteContentSlice_1.fetchDeleteAllContentStatus)(domain));
    }, [domain]);
    var onClickOnCancelButton = function () {
        if (currentJob && deleteAllContentActivated) {
            angularJsDependencies.deleteAllContent.setShowDeleteAllContentNotice(false);
            dispatch((0, deleteContentSlice_1.cancelContentDeletion)(domain, currentJob.jobId));
        }
    };
    var onClickOnConfirmButton = function () {
        dispatch((0, deleteContentSlice_1.deleteAllContent)(domain, Intl.DateTimeFormat().resolvedOptions().timeZone))
            .then(function () {
            setIsModalOpen(false);
            dispatch((0, deleteContentSlice_1.fetchDeleteAllContentStatus)(domain));
        })
            .catch(function () { return setIsModalOpen(true); });
    };
    return (react_1.default.createElement("div", { className: "col-xs-9 component" }, !status.loading && !status.error && (react_1.default.createElement("div", { className: "delete-all-content" },
        react_1.default.createElement(Title, { deleteAllContentActivated: deleteAllContentActivated, currentTeamName: currentTeamName }),
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-8" },
                react_1.default.createElement("p", { className: "main-text", dangerouslySetInnerHTML: {
                        __html: deleteAllContentActivated && currentJob
                            ? t('settings:DELETE_ALL_CONTENT.DELETION_SCHEDULED_TEXT_REACT', {
                                TIME: (0, date_1.formatDate)(new Date(currentJob.requestedTime)),
                                USER_NAME: currentJob.requestedByUser.name,
                                EMAIL: currentJob.requestedByUser.email,
                                REMAINING_TIME: currentJob.remainingTimeInText,
                                DEADLINE: (0, date_1.formatDate)(new Date(currentJob.scheduledAt)),
                            }) || ''
                            : t('settings:DELETE_ALL_CONTENT.TEXT1') || '',
                    } }),
                react_1.default.createElement("div", { className: "gdpr__button-group" }, deleteAllContentActivated ? (react_1.default.createElement(Button_1.default, { onClick: onClickOnCancelButton, text: t('settings:DELETE_ALL_CONTENT.CANCEL_DELETION_BUTTON') })) : (react_1.default.createElement(Button_1.default, { onClick: function () { return setIsModalOpen(true); }, text: t('settings:DELETE_ALL_CONTENT.DELETE_ALL_CONTENT_BUTTON') })))),
            react_1.default.createElement("div", { className: "col-md-4 right-side" },
                react_1.default.createElement(DeleteContentExplanation_1.DeleteContentExplanation, { willNotBeDeleted: res.willNotBeDeleted, willBeDeleted: res.willBeDeleted }))),
        react_1.default.createElement(Modal_1.default, { isOpen: isModalOpen, setIsOpen: setIsModalOpen },
            react_1.default.createElement(ConfirmContentDeletionModal_1.ConfirmContentDeletionModal, { currentTeamName: currentTeamName, setIsModalOpen: setIsModalOpen, onClickOnConfirmButton: onClickOnConfirmButton }))))));
}
exports.DeleteAllContent = DeleteAllContent;
